import React from "react";
import {sortableElement} from "react-sortable-hoc";

const SortableItem = sortableElement(props => <tr key={props['data-row-key']} {...props} />);

export default SortableItem